import { useCallback, useEffect, useState } from "react";

const EMPTY_SEARCHES = { preparation: "", assembly: "", qc: "", packing: "", dispatch: "" };

// AuthProvider owns this state, so route/floor unmounts do not discard it.
// Keep it in memory only: searches must not outlive the signed-in session.
export default function useFloorSearchState(user) {
  const scope = user?.id && user?.tenant_id
    ? JSON.stringify([user.tenant_id, user.id])
    : null;
  const [saved, setSaved] = useState({ scope, searches: EMPTY_SEARCHES });

  useEffect(() => {
    setSaved(previous => previous.scope === scope
      ? previous
      : { scope, searches: EMPTY_SEARCHES });
  }, [scope]);

  const clearFloorSearches = useCallback(() => {
    setSaved({ scope: null, searches: EMPTY_SEARCHES });
  }, []);

  const setFloorSearch = useCallback((floor, value) => {
    if (!scope || !Object.hasOwn(EMPTY_SEARCHES, floor)) return;
    setSaved(previous => ({
      scope,
      searches: {
        ...(previous.scope === scope ? previous.searches : EMPTY_SEARCHES),
        [floor]: value,
      },
    }));
  }, [scope]);

  return {
    floorSearches: scope && saved.scope === scope ? saved.searches : EMPTY_SEARCHES,
    setFloorSearch,
    clearFloorSearches,
  };
}
